<template>
  <div id="program">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button
              round
              type="info"
              size="mini"
              icon="fas fa-star"
              @click="
                rateDialog = !rateDialog;
                programRateId = null;
              "
              >{{ $t("contentManagement.eventProgram.ratings") }} <span v-if="$store.state.eventprogram.pendingProgramRateCount != 0">({{ $store.state.eventprogram.pendingProgramRateCount }})</span>
            </el-button>
          </li>
          <li class="nav-item">
            <el-button round type="warning" size="mini" icon="fas fa-calendar" @click="dayModal = true">{{ $t("contentManagement.eventProgram.days") }}</el-button>
          </li>
          <li class="nav-item">
            <el-button round type="warning" size="mini" icon="fas fa-paperclip" @click="subEventModal = !subEventModal">{{ $t("registrationManagement.subeventRegistrations.subevents") }}</el-button>
          </li>
          <li class="nav-item">
            <el-button round type="warning" size="mini" icon="fas fa-map-marker-alt" @click="saloonModal = !saloonModal">{{ $t("contentManagement.eventProgram.saloons") }}</el-button>
          </li>
          <li class="nav-item">
            <el-tooltip effect="dark" :content="$t('buttonGeneral.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="isFiltered ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>

          <li class="nav-item">
            <el-button
              round
              type="primary"
              size="mini"
              icon="fas fa-plus"
              @click="
                programId = null;
                programModal = true;
              "
              >{{ $t("contentManagement.eventProgram.addProgram") }}</el-button
            >
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("contentManagement.eventProgram.filter") }}</h5>
                <span>{{ $t("contentManagement.eventProgram.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="resetFilter" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round>{{ $t("event.buttons.close") }}</el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-8">
                  <label for>{{ this.$t("event.filter.search") }}</label>
                  <el-input clearable v-model="$store.state.eventprogram.filter.searchTerm" :placeholder="$t('event.textbox.filterLabel')"></el-input>
                </div>
                <div class="form-group col-md-4">
                  <label for>{{ $t("contentManagement.eventProgram.speaker") }}</label>
                  <SpeakerSearch @speakerSearchChanged="speakerSearchChanged" :key="refreshSpeaker" />
                </div>
                <div class="form-group col-md-4">
                  <label for>{{ this.$t("event.filter.day") }}</label>
                  <el-select v-model="$store.state.eventprogram.filter.dayId" :placeholder="$t('event.filter.day')">
                    <el-option v-for="item in $store.state.eventprogram.days" :key="item.id" :label="item.title" :value="item.id" :class="item.isActive ? '' : 'passive-items'"></el-option>
                  </el-select>
                </div>
                <div class="form-group col-md-4">
                  <label for>{{ this.$t("event.filter.stage") }}</label>
                  <el-select clearable v-model="$store.state.eventprogram.filter.saloonId" :placeholder="$t('event.filter.stage')">
                    <el-option v-for="item in $store.state.eventprogram.saloons" :key="item.id" :label="item.title" :value="item.id" :class="item.isActive ? '' : 'passive-items'">
                      <template>
                        <i class="fas fa-circle" :style="'color:' + item.color + '; margin-right: 6px;'"></i>
                        {{ item.title }}
                      </template>
                    </el-option>
                  </el-select>
                </div>
                <div class="form-group col-md-4">
                  <label for>{{ this.$t("event.table.subEvent") }}</label>
                  <el-select clearable v-model="$store.state.eventprogram.filter.subEventId" :placeholder="$t('event.table.subEvent')" @clear="$store.state.eventprogram.filter.subEventId = null">
                    <el-option v-for="item in $store.state.subevents.items" :key="item.id" :label="item.title" :value="item.id" :class="item.isActive ? '' : 'passive-items'"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.program.title") }}</h5>
              <span v-if="filteredProgram.length > 0" v-html="$t('totalContent', [filteredProgram.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body">
            <div class="days-and-saloons">
              <div class="saloons" @mouseleave="showSaloonList = false" v-if="$store.state.eventprogram.saloons != null && $store.state.eventprogram.saloons.length >= 1">
                <div class="custom-select-box" :class="{ active: showSaloonList }" @click="showSaloonList = true" v-if="selected != null">
                  <i class="fas fa-map-marker-alt map-icon"></i>
                  <div class="selected-content">
                    <div class="title">{{ selected.title }}</div>
                    <i class="el-icon-arrow-down"></i>
                  </div>
                  <transition name="el-zoom-in-top">
                    <div class="custom-list-container" v-show="showSaloonList">
                      <div class="custom-select-list">
                        <div class="select-item" @click="selectedSaloon(null)">
                          <i :style="{ color: '#03658C' }" class="fas fa-square mr-2"></i>
                          {{ $t("contentManagement.eventProgram.allSaloons") }}
                        </div>
                        <div class="select-item" v-for="saloon in $store.state.eventprogram.saloons" :key="saloon.id" @click="selectedSaloon(saloon)" :class="saloon.isActive ? '' : 'passive-items'">
                          <i :style="{ color: saloon.color }" class="fas fa-square mr-2"></i>
                          {{ saloon.title }}
                        </div>
                      </div>
                    </div>
                  </transition>
                  <div class="color" :style="{ 'background-color': selected.color }"></div>
                </div>
              </div>

              <div class="days" v-if="$store.state.eventprogram.days != null && $store.state.eventprogram.days.length >= 1" :style="$store.state.eventprogram.saloons != null && $store.state.eventprogram.saloons.length >= 1 ? '' : 'width: 100% !important;'">
                <VueSlickCarousel :key="$store.state.eventprogram.days.length + 'count'" v-if="$store.state.eventprogram.days.length > 0" :infinite="false" :focusOnSelect="true" :arrows="false" :slidesPerRow="5" :center-mode="false" class="day-slick">
                  <div class="item" v-for="(day, index) in $store.state.eventprogram.days" :key="index" @click="mutateFilterDayID(day.id)">
                    <div class="day-box" :class="(day.id == $store.state.eventprogram.filter.dayId ? 'selected' : '') + ' ' + (day.isActive ? '' : 'passive')">
                      <div class="day">{{ $moment(day.date).format("DD") }}</div>
                      <div class="dddd">{{ $moment(day.date).format("dddd") }}</div>
                      <div class="day-title">{{ day.title }}</div>
                    </div>
                  </div>
                </VueSlickCarousel>
              </div>
            </div>

            <!-- <div class="custom-grid-table-header program-grid-template">
              <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span>
              <div>{{ $t("contentManagement.eventProgram.event") }}</div>
              <div>{{ $t("contentManagement.speakers.viewing") }}</div>
              <div></div>
            </div> -->

            <div class="filter-warning" v-if="$store.state.eventprogram.filter.subEventId != null">
              <span>
                <i class="el-icon-info"></i>
                <span v-html="$t('contentManagement.eventProgram.showSubEvent', [$store.state.eventprogram.subEvents.find(x => x.id == $store.state.eventprogram.filter.subEventId) ? $store.state.eventprogram.subEvents.find(x => x.id == $store.state.eventprogram.filter.subEventId).title : ''])"></span>
              </span>
              <i class="el-icon-error" @click="$store.state.eventprogram.filter.subEventId = null"></i>
            </div>

            <draggable v-if="filteredProgram.length > 0" class="list-group-o program-list" :list="filteredProgram" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @start="dragList = true" @end="changeSort" :move="checkMove">
              <div class="item" v-for="(item, index) in filteredProgram" :key="item.id + index" :class="{ passive: !item.isActive, isSection: item.type == 2 && item.isActive }">
                <div class="content-area">
                  <div class="table-icon">
                    <i class="burger" :class="loading == item.id || activeIndex == index ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                  </div>
                  <div class="program-content">
                    <div class="head">
                      <div class="text-icon">
                        <i class="fas fa-clock"></i>
                        {{ item.startTime }} - {{ item.endTime }}
                      </div>
                      <div class="text-icon" v-if="item.saloonID != null" @click="$store.state.eventprogram.filter.saloonId = item.saloonID">
                        <i class="fas fa-map-marker-alt"></i>
                        {{ $store.state.eventprogram.saloons.find(x => x.id == item.saloonID) ? $store.state.eventprogram.saloons.find(x => x.id == item.saloonID).title : "" }}
                      </div>
                      <div class="text-icon" v-if="item.subEventID != null && item.type == 1" @click="$store.state.eventprogram.filter.subEventID = item.subEventID">
                        <i class="fas fa-link"></i>
                        {{ $store.state.eventprogram.subEvents.find(x => x.id == item.subEventID) ? $store.state.eventprogram.subEvents.find(x => x.id == item.subEventID).title : "" }}
                      </div>
                    </div>
                    <div class="program-title">
                      <i v-if="item.type == 3 && item.badgeTitle != null && item.badgeTitle != ''" :class="item.badgeTitle"></i>
                      {{ item.title }}
                    </div>
                    <div class="bottom">
                      <div class="info-text present" v-if="item.speakers.length >= 1" :class="{ active: item.show }" @click="item.show = !item.show">
                        {{ item.speakers.length }} {{ $t("contentManagement.eventProgram.speaker") }}
                        <i class="el-icon-arrow-down"></i>
                      </div>
                      <div class="info-text" v-if="item.rateCount != 0 && item.avgRate" @click="openRateDialog(item.id)">
                        {{ item.rateCount }} {{ $t("contentManagement.eventProgram.review") }}, {{ $t("contentManagement.eventProgram.avarage") }} {{ item.avgRate.toFixed(1) }}
                        <i class="fas fa-star"></i>
                      </div>
                    </div>
                  </div>
                  <div class="program-switch"><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="toggleItem(item.id)"></el-switch></div>
                  <div class="action-btns">
                    <el-tooltip effect="dark" :content="$t('contentManagement.eventProgram.sendReminderNotification')" placement="top">
                      <el-button size="mini" type="warning" circle icon="fas fa-bell"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                      <el-button
                        size="mini"
                        :type="item.type == 2 && item.isActive ? '' : 'primary'"
                        @click="
                          programId = item.id;
                          programModal = true;
                        "
                        circle
                        icon="fas fa-pen"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                      <el-popconfirm @confirm="deleteEventProgram(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                        <el-button slot="reference" type="danger" icon="fas fa-trash" :loading="loading == 'deleteProgram-' + item.id" circle size="mini"></el-button>
                      </el-popconfirm>
                    </el-tooltip>
                  </div>
                </div>
                <transition name="el-zoom-in-top" v-if="item.speakers.length > 0">
                  <template v-if="$store.state.eventprogram.speakers.length > 0">
                    <div class="speaker-area" v-show="item.show">
                      <div class="speaker-item" v-for="speaker in item.speakers" :key="speaker.id">
                        <template v-if="getSpeaker(speaker.speakerID)">
                          <div class="img" v-if="getSpeaker(speaker.speakerID).image != null" :style="'background-image:url(' + $imageus + getSpeaker(speaker.speakerID).image + '?width=150&height=150&mode=cover)'"></div>
                          <div class="speaker-info" v-if="getSpeaker(speaker.speakerID)">
                            <div class="speaker-title">
                              {{ getSpeaker(speaker.speakerID).fullName }}
                              <span v-if="getSpeaker(speaker.speakerID).title != null && getSpeaker(speaker.speakerID).title != ''"
                                >{{ getSpeaker(speaker.speakerID).title }}
                                <template v-if="getSpeaker(speaker.speakerID).firmName != null && getSpeaker(speaker.speakerID).firmName != ''">
                                  @ <b>{{ getSpeaker(speaker.speakerID).firmName }}</b></template
                                ></span
                              >
                            </div>
                            <div class="presentation" v-if="speaker.speakerPresentationId != null">{{ getSpeaker(speaker.speakerID).presentations.find(x => x.id == speaker.speakerPresentationId).title }}</div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </transition>
              </div>
            </draggable>
            <div v-else>
              <HolaconLottieNoData
                class="w-100"
                key="create-loading"
                :source="'holacon-programs-lottie'"
                :title="$t('event.menu.program.title')"
                @btnAdd="
                  programId = null;
                  programModal = true;
                "
                @btnRefresh="refreshList()"
                :buttonAdd="true"
                :buttonRefresh="true"
                :loading="loading"
              />
            </div>
          </div>

          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('registrationManagement.subeventRegistrations.subevents')" :close-on-click-modal="false" :visible.sync="subEventModal" class="large" center modal-append-to-body destroy-on-close>
      <EventSubEventList v-if="subEventModal" @closeDialog="subEventModal = false" />
    </el-dialog>
    <el-dialog :title="$t('contentManagement.eventProgram.days')" :close-on-click-modal="false" :visible.sync="dayModal" class="large" center modal-append-to-body destroy-on-close>
      <EventDayAddUpdate v-if="dayModal" @closeDialog="dayModal = false" />
    </el-dialog>

    <el-dialog :title="$t('contentManagement.eventProgram.saloons')" :close-on-click-modal="false" :visible.sync="saloonModal" class="large" center modal-append-to-body destroy-on-close>
      <EventSaloonAddUpdate v-if="saloonModal" @closeDialog="saloonModal = false" />
    </el-dialog>

    <el-dialog :title="programId == null ? $t('contentManagement.eventProgram.addProgram') : $t('contentManagement.eventProgram.editProgram')" :close-on-click-modal="false" :visible.sync="programModal" class="xlarge" center modal-append-to-body destroy-on-close>
      <EventProgramAddUpdate :id="programId" @deleteMe="deleteEventProgram" v-if="programModal" @closeDialog="programModal = false" />
    </el-dialog>
    <el-dialog :title="$t('contentManagement.eventProgram.ratings')" class="large" modal-append-to-body destroy-on-close :close-on-click-modal="false" :visible.sync="rateDialog">
      <EventProgramRate v-if="rateDialog" @closeDialog="rateDialog = false" :id="programRateId" />
    </el-dialog>
  </div>
</template>

<script>
import slugify from "slugify";

import EventProgramRate from "../../components/eventprogram/EventProgramRate.vue";
import draggable from "vuedraggable";
import EventDayAddUpdate from "../../components/eventprogram/EventDayAddUpdate.vue";
import EventSaloonAddUpdate from "../../components/eventprogram/EventSaloonAddUpdate.vue";
import EventProgramAddUpdate from "../../components/eventprogram/EventProgramAddUpdate.vue";
import EventSubEventList from "../../components/eventprogram/EventProgramSubEventList.vue";
import VueSlickCarousel from "vue-slick-carousel";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import SpeakerSearch from "../../components/SpeakerSearch";
export default {
   metaInfo() {
    return {
      title: this.$t("eventPageTitle.eventProgram")
    };
  },
  components: {
    SpeakerSearch,
    draggable,
    VueSlickCarousel,
    EventDayAddUpdate,
    EventSaloonAddUpdate,
    EventSubEventList,
    EventProgramAddUpdate,
    EventProgramRate,
    draggable
  },
  name: "Program",
  data() {
    return {
      programRateId: null,
      testShow: false,
      programId: null,
      programModal: null,
      showSaloonList: false,
      selected: null,
      axios,
      saloonModal: false,
      dayModal: false,
      isFilterEnabled: false,
      subEventModal: false,
      timeout: null,
      helpUrl: this.$helpUrl + "tags",
      isExpanded: false,
      drag: false,
      rateDialog: false,
      loading: false,
      listShort: null,
      programSort: null,
      refreshSpeaker: +new Date(),
      activeIndex: null
    };
  },
  methods: {
    openRateDialog(id) {
      this.programRateId = id;
      this.rateDialog = !this.rateDialog;
    },
    checkMove(e) {
      this.activeIndex = e.draggedContext.futureIndex;
    },

    mutateFilterDayID(id) {
      this.$store.commit("eventFilterDayId", id);
    },

    getTime(time) {
      return this.$moment()
        .set({ hours: time.hours, minutes: time.minutes })
        .format("HH:mm");
    },

    getDate(date) {
      return this.$moment(date).format("Do MMMM YYYY");
    },

    speakerSearchChanged(val) {
      this.$store.state.eventprogram.filter.speakerId = val;
    },

    expandRow() {
      this.isExpanded = !this.isExpanded;
      this.$store.state.program.items.map(i => {
        this.$refs.multipleTable[0].toggleRowExpansion(i, this.isExpanded);
      });
    },

    getSpeaker(id) {
      var speaker = this.$store.state.eventprogram.speakers.find(x => x.id == id);
      return speaker;
    },

    async changeSort() {
      if (this.programSort != null) clearTimeout(this.programSort);
      this.loading = "loadingList";
      this.programSort = setTimeout(async () => {
        if (this.filteredProgram.length > 0) {
          var payload = [];
          this.filteredProgram.map(x => {
            payload.push(x.id);
          });
          await this.$store.dispatch("saveProgramOrders", {
            ids: payload,
            dayId: this.$store.state.eventprogram.filter.dayId
          });
          await this.$store.dispatch("getEventProgram");
        }
        this.loading = false;
        this.activeIndex = null;
      }, 500);
      this.dragList = false;
    },

    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("togglerProgram", id);
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },

    async deleteEventProgram(id) {
      this.loading = "deleteProgram-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteEventProgram", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getEventProgram");
        }
        this.loading = false;
      }, 500);
    },

    async selectedSaloon(item) {
      if (item == null) {
        this.selected = {
          title: this.$t("contentManagement.eventProgram.allSaloons"),
          color: "#03658C",
          id: null
        };
        this.$store.state.eventprogram.filter.saloonId = null;
      } else {
        this.selected = item;
        this.$store.state.eventprogram.filter.saloonId = item.id;
      }

      this.showSaloonList = false;
    },

    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getEventProgram");
      if (this.$store.state.eventprogram.days.length > 0) {
        this.$store.state.eventprogram.filter.dayId = this.$store.state.eventprogram.days[0].id;
      } else {
        this.$store.state.eventprogram.filter.dayId = null;
      }
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },

    resetFilter() {
      this.$store.state.eventprogram.filter.searchTerm = null;
      this.$store.state.eventprogram.filter.saloonId = null;
      this.$store.state.eventprogram.filter.speakerId = null;
      this.$store.state.eventprogram.filter.subEventId = null;
      this.refreshSpeaker++;
    }
  },

  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await Promise.all([this.$store.dispatch("getEventProgram"), this.$store.dispatch("getSpeakers")]);
      if (this.$store.state.eventprogram.days.length > 0) {
        this.$store.state.eventprogram.filter.dayId = this.$store.state.eventprogram.days[0].id;
      } else {
        this.$store.state.eventprogram.filter.dayId = null;
      }
      await this.$nextTick(() => {
        this.selected = {
          title: this.$t("contentManagement.eventProgram.allSaloons"),
          color: "#03658C",
          id: null
        };
        this.$store.state.eventprogram.filter.saloonId = null;
      });
      this.loading = false;
    }, 500);
  },
  computed: {
    getSearchTerm() {
      return slugify(this.$store.state.eventprogram.filter.searchTerm == null ? "" : this.$store.state.eventprogram.filter.searchTerm, {
        replacement: " ",
        lower: true
      });
    },
    filteredProgram() {
      var items = this.$store.state.eventprogram.items.filter(
        x => x.dayID == this.$store.state.eventprogram.filter.dayId && (this.$store.state.eventprogram.filter.saloonId != null ? x.saloonID == this.$store.state.eventprogram.filter.saloonId : true) && (this.$store.state.eventprogram.filter.subEventId != null ? x.subEventID == this.$store.state.eventprogram.filter.subEventId : true) && (this.$store.state.eventprogram.filter.speakerId != null ? x.speakers.some(x => x.speakerID == this.$store.state.eventprogram.filter.speakerId) : true)
      );
      var regex = new RegExp(this.getSearchTerm, "g");
      if (this.getSearchTerm == null || this.getSearchTerm == "") return items;
      return items.filter(
        k =>
          slugify(k.title, " ")
            .toLowerCase()
            .match(regex) || slugify(k.title, " ").match(regex)
      );
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

    isFiltered() {
      return (this.$store.state.eventprogram.filter.searchTerm != null && this.$store.state.eventprogram.filter.searchTerm != "") || (this.$store.state.eventprogram.filter.saloonId != null && this.$store.state.eventprogram.filter.saloonId != "") || (this.$store.state.eventprogram.filter.subEventId != null && this.$store.state.eventprogram.filter.subEventId != "") || (this.$store.state.eventprogram.filter.speakerId != null && this.$store.state.eventprogram.filter.speakerId != "");
    }
  },
  watch: {
    "$store.state.eventprogram.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getEventProgram");
      }, 500);
    },
    "$store.state.eventprogram.filter.dayId": function(newVal, oldVal) {
      this.$store.state.eventprogram.items = [];
      this.$store.dispatch("getEventProgram");
    },
    "$store.state.eventprogram.filter.saloonId": function(newVal, oldVal) {
      this.$store.dispatch("getEventProgram");
      if (this.$store.state.eventprogram.saloons.find(x => x.id == this.$store.state.eventprogram.filter.saloonId) != null) {
        this.selected = {
          title: this.$store.state.eventprogram.saloons.find(x => x.id == this.$store.state.eventprogram.filter.saloonId).title,
          color: this.$store.state.eventprogram.saloons.find(x => x.id == this.$store.state.eventprogram.filter.saloonId).color,
          id: this.$store.state.eventprogram.saloons.find(x => x.id == this.$store.state.eventprogram.filter.saloonId).id
        };
      }
      if (this.$store.state.eventprogram.filter.saloonId == "") {
        this.$store.state.eventprogram.filter.saloonId = null;
        this.selectedSaloon(null);
      }
    },
    "$store.state.eventprogram.filter.subEventId": function() {
      this.$store.dispatch("getEventProgram");
    },
    "$store.state.eventprogram.filter.speakerId": function() {
      this.$store.dispatch("getEventProgram");
    },
    drag: function(newVal) {
      if (newVal == false) {
        this.saveSorting();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.program-grid-template {
  grid-template-columns: 30px 1fr 90px 90px;
}

.passive-items {
  background-color: #fff2f2;
}
.list-group {
  background-color: unset;
  border: unset;
  padding: 0px;
  background-clip: padding-box;
  border-radius: unset;
  width: 100%;
}

.custom-saloon-list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
  padding: 0.5rem;
  gap: 0.5rem;
  font-size: 15px;
  line-height: 15px;
  .circle-color-pick {
    width: 15px;
    height: 15px;
    border-radius: 50%;
  }
}
.seperator .date {
  width: 100%;
  display: block;
}
.card-body {
  .filter-warning {
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background-color: rgba(255, 168, 0, 0.16);
    margin-bottom: 10px;
    span {
      font-size: 14px;
      color: #292f3b;
      font-weight: 500;
      b {
        font-weight: 600;
      }
      i {
        color: #ffa800;
        font-size: 16px;
        margin-right: 8px;
      }
    }

    i {
      font-size: 16px;
      color: #292f3b;
      cursor: pointer;
    }
  }
  .days-and-saloons {
    display: flex;
    flex-direction: row;
    min-height: 125px;
    margin-bottom: 20px;
    width: 100%;
    background-color: white;
    .saloons {
      flex-shrink: 0;
      width: 300px;
      padding: 17px 0px;
      display: flex;
      align-items: center;
    }
    .days {
      width: calc(~"100% - 320px");
      display: flex;
      align-items: center;
      margin-left: 20px;
    }
  }
}
.day-slick {
  width: 100%;
  .item {
    cursor: pointer;
    padding: 0.2rem;
    min-width: 120px;

    &.active {
      .day-box {
        .day {
          background-color: #03658c;
          color: white;
        }
      }
    }
    .day-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      background-color: #f1f1f1;
      border-radius: 8px;

      &.selected {
        .day {
          background-color: #03658c !important;

          color: white;
        }
        .day-title {
          color: #03658c;
        }
      }
      &.passive {
        .day {
          background-color: #fff2f2;
          border-color: #f22f2f;
        }

        .dddd {
          color: #f22f2f;
        }
      }
      .day {
        padding: 9px;
        border-radius: 50%;
        width: 40px;
        text-align: center;
        height: 40px;
        margin-top: 6px;
        margin-bottom: 4px;
        font-size: 14px;
        color: #292f3b;
        font-weight: 600;
        background-color: white;
      }
      .dddd {
        font-size: 13px;
        color: #505763;
        font-weight: 500;
      }
      .day-title {
        font-size: 13px;
        color: #292f3b;
        font-weight: 600;
      }
    }
  }
}
.custom-select-box {
  background-color: #f1f1f1;
  border-radius: 8px;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .map-icon {
    color: white;
    font-size: 45px;
  }

  .color {
    position: absolute;
    bottom: 6px;
    height: 4px;
    width: calc(~"100% - 16px");
    margin: 0px 8px;
    border-radius: 2px;
  }

  &.active {
    .selected-content {
      i {
        transition: all 0.5s;

        transform: rotate(-180deg);
      }
    }
  }
  .selected-content {
    user-select: none;
    margin-left: 8px;
    width: calc(~"100% - 110px");
    display: flex;
    flex-direction: column;
    font-weight: bold;

    .title {
      color: #292f3b;
      font-size: 14px;
    }

    i {
      transition: all 0.5s;
      position: absolute;
      right: 8px;
      font-size: 16px;
      top: calc(~"50% - 7.5px");
      font-weight: bold;
    }
  }

  .custom-list-container {
    position: absolute;
    left: 0;
    top: calc(~"100%");
    width: 100%;
    padding-top: 15px;
    z-index: 2;

    .custom-select-list {
      background: white;
      box-shadow: 0px 2px 12px -4px rgba(0, 0, 0, 0.36);
      min-height: 40px;
      overflow: hidden;
      border-radius: 8px;
      .select-item {
        padding: 10px 12px;
        &:hover {
          background-color: #f1f1f1;
        }
        display: flex;
        flex-direction: row;
        gap: 0.3rem;
        i {
          font-size: 16px;
          margin-right: 6px;
        }
        font-size: 13px;
        line-height: 16px;
        align-items: center;
        font-weight: 600;
        color: #292f3b;
      }
    }
  }
}
</style>
<style lang="less">
.modal-base-small {
  min-width: 700px !important;
}
.modal-base-md {
  min-width: 1140px !important;
}
.slick-prev {
  &:before {
    font-family: element-icons !important;
    content: "\e6de" !important;
    color: black;
    font-weight: bold;
    font-size: 24px;
  }
}
.slick-next {
  &:before {
    font-family: element-icons !important;
    content: "\e6e0" !important;
    color: black;
    font-weight: bold;
    font-size: 24px;
  }
}
// .saloon-select {
//   .el-input {
//     height: auto !important;
//     input {
//       min-height: 60px;
//       height: 100% !important;
//       padding: 0 15px !important;
//     }
//     .el-input__prefix {
//       .option-select {
//         width: 85%;
//         text-align: start;
//         font-weight: bold;
//         color: black;
//         .title {
//           width: 50%;
//         }
//       }
//       min-height: 60px;
//       height: unset;
//       padding: 1rem;
//       width: 100% !important;
//       left: 0 !important;
//       position: absolute;
//       background: white;
//       pointer-events: none;
//       border: 0.5px solid #d6d9d9;
//       border-radius: 7px;
//       overflow: hidden;
//       display: flex;
//       flex-direction: row;
//       justify-content: center;
//       .color {
//         height: 4px;
//       }
//     }
//   }
// }
.program-list {
  display: flex;
  flex-direction: column;
  .item {
    margin-bottom: 8px;
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;

    &.isSection {
      background-color: #03658c;
      .speaker-area {
        .speaker-item {
          .speaker-info {
            .speaker-title {
              color: white !important;
              span {
                color: rgb(214, 190, 190);
              }
            }
            .presentation {
              color: rgb(214, 190, 190) !important;
            }
          }
        }
      }
      .content-area {
        .table-icon {
          .burger {
            color: white;
          }
        }

        .program-content {
          .head {
            .text-icon {
              color: white;
              i {
                color: white;
              }
            }
          }

          .program-title {
            color: white;
          }
        }

        .program-switch {
          .el-switch.is-checked .el-switch__core {
            border-color: white;
            background-color: white;
            &::after {
              background-color: #03658c;
            }
          }
        }
      }
    }

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }
    .speaker-area {
      border-top: 1px solid white;
      padding: 10px;
      display: flex;
      flex-direction: column;
      gap: 0.3rem;

      .speaker-item {
        display: flex;
        gap: 0.5rem;
        font-weight: 500;
        align-items: center;
        width: 100%;
        & > .img {
          border-radius: 50%;
          width: 55px;
          height: 55px;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          overflow: hidden;
          border: 3px solid white;
        }
        .speaker-info {
          display: flex;
          flex-direction: column;
          .speaker-title {
            font-size: 14px;
            color: #292f3b;
            font-weight: 600;
            line-height: normal;
            span {
              font-size: 13px;
              display: block;
              font-weight: 500;
              color: #505763;
              line-height: normal;
            }
          }
          .presentation {
            color: #03658c;
            font-weight: 500;
          }
        }
        img {
          width: 55px;
          height: 55px;
          border-radius: 50%;
        }
      }
    }
    .content-area {
      padding: 10px;
      display: grid;
      align-items: center;
      grid-template-columns: 36px 1fr 90px 100px;

      .action-btns {
        button {
          &:nth-child(2) {
            margin-left: unset !important;
          }
        }
      }

      .program-content {
        display: flex;
        flex-direction: column;

        .head {
          display: flex;
          flex-direction: row;
          align-items: center;

          .text-icon {
            font-size: 13px;
            color: #292f3b;
            font-weight: 500;
            margin-right: 12px;
            cursor: pointer;

            &:first-child {
              cursor: default;
            }

            &:last-child {
              margin-right: unset;
            }

            i {
              font-size: 13px;
              color: #03658c;
              margin-right: 4px;
            }
          }
        }
        .program-badge {
          i {
            color: #03658c;
          }
        }
        .program-title {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 750px;
          padding: 8px 0px;

          i {
            font-size: 16px;
            color: #03658c;
            margin-right: 6px;
          }
        }
        .bottom {
          display: flex;
          flex-direction: row;
          gap: 0.5rem;
          .info-text {
            padding: 5px 10px;
            width: max-content;
            border-radius: 8px;
            background-color: rgba(255, 255, 255, 0.8);
            font-weight: 600;
            color: #505763;
            font-size: 13px;
            gap: 0.5rem;
            cursor: pointer;
            &.present {
              transform: rotate(0deg);
              transition: all 0.4s ease-in-out;

              &.active {
                i {
                  transform: rotate(-180deg);
                  transition: all 0.4s ease-in-out;
                }
              }
              align-items: center;
              i {
                font-size: 14px;
                color: #292f3b;
                margin-left: 4px;
              }
            }
            i {
              font-weight: bold;
              font-size: 14px;
              &.fa-star {
                color: #f1c232;
              }
            }
          }
        }
      }
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }

    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Program.vue